import React, { FC, useEffect } from 'react';
import { Typography } from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from 'utils/contexts/auth-context';
import axios from 'utils/services/axios';

import LoadingSpinner from 'components/LoadingSpinner/loading-spinner';
import Page from 'components/page/page.component';

const Redirect: FC = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code') || '';
  const navigate = useNavigate();
  const { setAccessToken, accessToken } = useAuth();

  const getUserInfo = async () => {
    if (!accessToken) {
      try {
        const { data } = await axios.get('redirect', {
          withCredentials: true,
          params: { code },
        });
        setAccessToken(data);
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (e) {
        console.log(e);
      }
    } else {
      navigate('/login');
    }
  };

  useEffect(() => {
    if (code) {
      getUserInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  return (
    <Page pageTitle='Redirect'>
      <Typography variant='subtitle1'>Please wait...</Typography>
      <Typography variant='caption'>We’re loading the app</Typography>
      <LoadingSpinner />
    </Page>
  );
};

export default Redirect;
